// extracted by mini-css-extract-plugin
export default {"contentHeaderTitle":"ef8g6px7"};